import React, {useRef} from 'react';

export const useDialog = (DialogComp) => {
    const [isOpen, setOpen] = React.useState(false);
    const dialogProps = useRef()

    const handleClickOpen = (props) => {
        dialogProps.current = props
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };
    return {
        DialogComp: isOpen ? <DialogComp isOpen={isOpen} handleClose={handleClose} {...dialogProps.current} /> : null,
        handleClickOpen
    }
}

export const useConfirmDialog = (DialogComp) => {
    const [isOpen, setOpen] = React.useState(false);
    const promise = useRef()
    const dialogProps = useRef()

    const handleClickOpen = (props) => {
        dialogProps.current = props
        setOpen(true);
        return new Promise((res) => {
            promise.current = res;
        });
    };

    const handleCancel = (e) => {
        e.stopPropagation();
        promise.current(false)
        setOpen(false);
    };

    const handleApprove = (e, answer) => {
        e.stopPropagation();
        promise.current(answer || true)
        setOpen(false);
    };

    return {
        DialogComp: isOpen ? <DialogComp isOpen={isOpen} handleApprove={handleApprove}
                                         handleCancel={handleCancel} {...dialogProps.current}/> : null,
        handleClickOpen
    }
}
